import { Modal } from 'antd';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PlatformAdminRow } from '../../../../models/entities/platform/platformSuperAdmin';
import { platformSuperAdminSelectors } from '../../../../state/ducks/platformSuperAdmin/selectors';
import { platformUsersSelectors } from '../../../../state/ducks/platformUsers/selectors';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import { RootState } from '../../../../state/store/store';
import PlatformSuperAdminsPage from './PlatformSuperAdminsPage';

type Props = {
    rows: PlatformAdminRow[];
    users: ReturnType<typeof platformUsersSelectors.users>;
    localization: any;
    showLoader: boolean;
    lastError: string | null;
    fetchPlatformAdmins: () => void;
    fetchUsers: () => void;
    addPlatformAdmin: (email: string) => Promise<void>;
    revokePlatformAdmin: (email: string) => Promise<void>;
};

const PlatformSuperAdminsPageConnected = ({
    rows,
    users,
    localization,
    showLoader,
    lastError,
    fetchPlatformAdmins,
    fetchUsers,
    addPlatformAdmin,
    revokePlatformAdmin
}: Props) => {
    useEffect(() => {
        fetchPlatformAdmins();
        fetchUsers();
    }, [fetchPlatformAdmins, fetchUsers]);

    const handleRevoke = (email: string) => {
        Modal.confirm({
            title: localization.revoke_confirm.title,
            content: localization.revoke_confirm.content.replace('{email}', email),
            okText: localization.revoke_confirm.ok,
            cancelText: localization.revoke_confirm.cancel,
            onOk: () => revokePlatformAdmin(email)
        });
    };

    return (
        <PlatformSuperAdminsPage
            rows={rows}
            users={users}
            localization={localization}
            showLoader={showLoader}
            lastError={lastError}
            fetchPlatformAdmins={fetchPlatformAdmins}
            addPlatformAdmin={addPlatformAdmin}
            revokePlatformAdmin={handleRevoke}
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    rows: platformSuperAdminSelectors.rows(state),
    users: platformUsersSelectors.users(state),
    showLoader:
        !!state.loading.effects.platformSuperAdmin.fetchPlatformAdmins ||
        !!state.loading.effects.platformSuperAdmin.addPlatformAdmin ||
        !!state.loading.effects.platformSuperAdmin.revokePlatformAdmin,
    lastError: platformSuperAdminSelectors.lastError(state),
    localization: localizationSelectors.platformSuperAdminsPage(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchPlatformAdmins: () => dispatch.platformSuperAdmin.fetchPlatformAdmins(),
    fetchUsers: () => dispatch.platformUsers.fetchUsers(),
    addPlatformAdmin: (email: string) => dispatch.platformSuperAdmin.addPlatformAdmin(email),
    revokePlatformAdmin: (email: string) => dispatch.platformSuperAdmin.revokePlatformAdmin(email)
});

export default connect(mapStateToProps, mapDispatchToProps)(PlatformSuperAdminsPageConnected);
